module.exports = __webpack_public_path__ + "static/media/download-on-the-app-store-apple-logo-svgrepo-com.a053740f.svg";